import { useClientSideTableFilter } from "~components/DataTable/hooks/useClientSideTableFilter.ts";
import type { ClientSideTableSearchField } from "~components/DataTable/types/clientSideTableSearchField.ts";
import { filterByTableField } from "~components/DataTable/utils/filterByTableField.ts";
import { EntityGroupTableColumns } from "~pages/EntityGroups/EntityGroupListPage/enums/entityGroupTableColumns.ts";
import { EntityGroupTableFilterTypes } from "~pages/EntityGroups/EntityGroupListPage/enums/entityGroupTableFilterTypes.ts";
import type { EntityGroup } from "~types/entityGroup.ts";

const entityGroupSearchFields: Array<ClientSideTableSearchField<EntityGroup>> = [EntityGroupTableColumns.NameFullLocal];

const entityGroupFilterFunctions = {
  [EntityGroupTableFilterTypes.Status]: filterByTableField<EntityGroup>(EntityGroupTableColumns.Status),
};

type Props = {
  entityGroups: Array<EntityGroup>;
  currentFilter: Record<string, unknown>;
  searchText: string;
};

export const useFilteredEntityGroups = ({ entityGroups, currentFilter, searchText }: Props) => {
  return useClientSideTableFilter({
    data: entityGroups,
    currentFilter,
    filterFunctions: entityGroupFilterFunctions,
    searchText,
    searchFields: entityGroupSearchFields,
  }).filteredData;
};
